export default __webpack_public_path__ + "static/media/bank_melli.0b08294f.png";